
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Shirditopunecab() {



    const cardData =
    {
        keyword: 'Shirdi to Pune Cab',
        heading: 'S9 Travels:  Shirdi to Pune Cab',
        headingDescription: 'S9 Travels offers reliable and hassle-free Shirdi to Pune cab services, perfect for travelers returning home after a peaceful visit to the Sai Baba Temple or planning a business or leisure trip to Pune. The road distance between Shirdi and Pune is about 185 kilometers, usually covered in 4 to 5 hours through scenic routes passing Ahmednagar. Our fleet includes AC sedans, SUVs, and Innova Crysta cabs, all maintained to the highest standards for your comfort and safety. With professional chauffeurs, on-time pickups, and 24×7 customer support, we ensure a smooth and enjoyable journey. Whether you need a one-way cab, round-trip package, or doorstep pickup from your Shirdi hotel, S9 Travels guarantees affordable fares, clean vehicles, and a comfortable travel experience every time.',

        top: 'Top Places to Visit in Pune with S9 Travels',

"topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Shaniwar Wada is a historic fortification in Pune, built in 1732. It was the seat of the Peshwas of the Maratha Empire. The fort is known for its majestic architecture, intricate carvings, and historical significance."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Aga Khan Palace is a historic landmark that played a crucial role in India’s freedom struggle. It served as a prison for Mahatma Gandhi and his associates during the Quit India Movement. The palace is now a museum displaying various artifacts related to Gandhi’s life."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Perched atop a hill, Sinhagad Fort is a historic site that offers breathtaking views of the surrounding landscape. It is known for its significance in Maratha history and is a popular trekking destination for adventure enthusiasts."
    },
    {
      "title": "Dagdusheth Halwai Ganpati Temple",
      "description": "This famous temple is dedicated to Lord Ganesha and attracts thousands of devotees every year. Known for its beautiful idol adorned with gold and jewelry, the temple is a must-visit for spiritual seekers and tourists alike."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "An ancient rock-cut temple dedicated to Lord Shiva, the Pataleshwar Cave Temple dates back to the 8th century. It is a significant architectural and historical site, offering a serene and spiritual experience."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This fascinating museum houses an extensive collection of artifacts, sculptures, musical instruments, and everyday objects from Indian history. It provides a glimpse into India’s rich cultural heritage."
    },
    {
      "title": "Vetal Tekdi",
      "description": "Vetal Tekdi is a popular hill in Pune known for its scenic beauty and trekking trails. It is an ideal spot for nature lovers and fitness enthusiasts looking for an early morning hike or a peaceful escape from the city."
    },
    {
      "title": "Pashan Lake",
      "description": "Pashan Lake is a tranquil artificial lake that serves as a great spot for birdwatching and leisurely walks. It’s a perfect place to unwind amidst nature and enjoy the peaceful surroundings."
    },
    {
      "title": "Osho Ashram",
      "description": "Located in Koregaon Park, the Osho International Meditation Resort is a world-renowned spiritual retreat offering meditation programs, wellness therapies, and a serene environment for self-discovery."
    },
    {
      "title": "FC Road and JM Road",
      "description": "Fergusson College Road (FC Road) and Jangali Maharaj Road (JM Road) are bustling streets famous for their shopping, street food, and lively ambiance. From trendy clothes to delicious street snacks, these roads are a paradise for youngsters and shopaholics."
    }
],

"services": [
    {
      "name": "Mumbai to Pune Innova Cab",
      "description": "For travelers heading back to Pune from Mumbai Airport, our Innova cabs provide a comfortable and spacious ride. Book your Mumbai to Pune Innova cab and enjoy a smooth, enjoyable ride after your flight."
    },
    {
      "name": "Mumbai to Pune One-Way Innova",
      "description": "If you're flying into Mumbai Airport and need a one-way ride to Pune, our Innova one-way cab service provides a convenient, comfortable, and cost-effective way to travel. Sit back and relax while we take you to your destination."
    },
    {
      "name": "Private Innova Cab from Pune to Mumbai Airport",
      "description": "Book a private Innova cab for your Pune to Mumbai Airport trip. Whether you’re traveling alone, with family, or in a group, having a private vehicle ensures that you can travel in privacy and comfort."
    },
    {
      "name": "Luxury Innova for Mumbai Airport",
      "description": "For those looking for a luxury ride to Mumbai Airport, our luxury Innova cabs offer premium features such as plush seating, air conditioning, and a smooth ride for a top-tier travel experience. Perfect for business travelers or those looking for extra comfort."
    },
    {
      "name": "Affordable Pune to Mumbai Airport Innova",
      "description": "Travel affordably with an Innova taxi from Pune to Mumbai Airport. We offer competitive prices without compromising on comfort. Whether it’s a solo trip or with family, our affordable Innova taxis ensure great value for money."
    },
    {
      "name": "Group Travel to Mumbai Airport by Innova",
      "description": "Traveling with a group? Our Innova cabs are ideal for group travel to Mumbai Airport. With ample space for luggage and passengers, everyone can travel together in comfort. Book a group travel Innova for a smooth and enjoyable airport trip."
    },
    {
      "name": "Pune to Mumbai Airport Round Trip Innova",
      "description": "For those who need a round-trip taxi to Mumbai Airport, our Innova cabs offer a great option. Book a round trip to ensure you have a reliable vehicle both ways. Our round-trip service includes pick-up from Pune, a safe journey to the airport, and a return trip after your flight."
    }
  ],
  "tableData": [
    ["Mumbai to Pune Innova Cab", "Mumbai to Pune One-Way Innova"],
    ["Private Innova Cab from Pune to Mumbai Airport", "Luxury Innova for Mumbai Airport"],
    ["Affordable Pune to Mumbai Airport Innova", "Mumbai to Pune Innova Cab"],
    ["Group Travel to Mumbai Airport by Innova", "Pune to Mumbai Airport Round Trip Innova"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we ensure that your journey from Shirdi to Pune is comfortable and timely. We offer prompt pickups from your location in Shirdi and guarantee a smooth, hassle-free drive. Our drivers are punctual and dedicated to ensuring you reach your destination on time."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "Our Toyota Innova is the perfect choice for your journey from Shirdi to Pune. Equipped with comfortable seating, air conditioning, and plenty of space for luggage, you can relax and enjoy a comfortable, stress-free trip. Whether you're traveling solo or with family or friends, you'll experience comfort all the way."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are highly experienced and familiar with the best routes from Shirdi to Pune. They are professional, courteous, and knowledgeable, ensuring that your trip is smooth, safe, and enjoyable. You can rely on them for a hassle-free journey."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Shirdi to Pune ride. You'll receive a clear breakdown of all costs upfront, with no hidden charges, so you can plan your travel budget with ease."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Safety is our top priority. Our Toyota Innova vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking, ensuring you have a secure and comfortable ride throughout your journey from Shirdi to Pune."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "S9 Travels is available 24/7, no matter when you need to travel from Shirdi to Pune. Whether you need an early morning or late-night ride, we are always ready to serve you, and our customer service team is available around the clock to assist with bookings."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Shirdi to Pune cab is easy and convenient with S9 Travels. You can book online via our website or mobile app, or contact our customer service team for personalized assistance in securing your ride."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "If you have specific preferences or need additional services during your journey, we offer customized travel packages for your Shirdi to Pune trip. Whether you need to make stops along the way or have specific requests, we tailor the experience to meet your needs."
  }
]












    }



    const faqData = [
        [
          {
            question: 'How can I book a cab from Shirdi to Pune with S9 Travels?',
            answer: 'Booking a cab for your Shirdi to Pune trip is simple! You can book online through our website or mobile app, or contact our customer service team for assistance with your booking.'
          },
          {
            question: 'What types of cabs are available for Shirdi to Pune travel?',
            answer: 'We offer a variety of cabs, including the spacious Toyota Innova, perfect for families, groups, or travelers with a lot of luggage. Choose the vehicle that best fits your needs for a comfortable journey.'
          },
          {
            question: 'Are the drivers experienced for the Shirdi to Pune route?',
            answer: 'Yes, our drivers are experienced and familiar with the best routes from Shirdi to Pune. They ensure a smooth, safe, and timely journey, making sure you reach your destination comfortably.'
          },
          {
            question: 'What payment options are available for booking a cab from Shirdi to Pune?',
            answer: 'We offer flexible payment options, including cash, credit/debit cards, and secure online payments via our mobile app, providing convenience and flexibility.'
          },
          {
            question: 'Can I book a round trip from Shirdi to Pune?',
            answer: 'Yes, we offer round-trip bookings. Simply provide us with your return details, and we’ll arrange a smooth and comfortable ride back from Pune to Shirdi.'
          },
          {
            question: 'Are there any extra charges for detours or waiting time during the trip?',
            answer: 'Any extra charges, such as for detours or waiting time, will be communicated to you upfront, ensuring full transparency in the pricing.'
          },
          {
            question: 'Can I make additional stops on the way from Shirdi to Pune?',
            answer: 'Yes, you can request additional stops. Please inform us during the booking process, and we’ll accommodate your requests for stops along the way.'
          },
          {
            question: 'What is the luggage allowance for a cab on the Shirdi to Pune trip?',
            answer: 'The Toyota Innova offers ample space for standard luggage. If you have more luggage or special requirements, please inform us when booking, and we will make the necessary arrangements.'
          },
          {
            question: 'Does S9 Travels provide corporate travel services for Shirdi to Pune?',
            answer: 'Yes, we offer corporate travel services for business trips from Shirdi to Pune, ensuring that your journey is comfortable, punctual, and professional.'
          },
          {
            question: 'Why should I choose S9 Travels for my Shirdi to Pune cab booking?',
            answer: 'S9 Travels offers a reliable, safe, and comfortable ride with professional drivers, well-maintained vehicles, and excellent customer service, ensuring a smooth and enjoyable journey from Shirdi to Pune.'
          }
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Subhash Patel',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a ride from Shirdi to Pune with S9 Travels, and I was very impressed with the service. The driver was professional, the car was clean, and the journey was comfortable. Highly recommended for anyone traveling from Shirdi to Pune!”'
        },
        {
          name: 'Mrs. Priya Thakur',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our family used S9 Travels for a trip from Shirdi to Pune, and it was a wonderful experience. The vehicle was spacious, the driver was courteous, and the ride was smooth. I’ll definitely use their services again for future trips!”'
        }
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
      
      

//    const productSchema = {
//   "@context": "https://schema.org",
//   "@type": "Product",
//   "name": "Shirdi to Pune Cab",
//   "image": "https://www.s9travels.com/images/keyword/shirdi-to-pune-cab.jpg", // Replace with the actual image path
//   "description": "Book a comfortable and affordable Shirdi to Pune cab with S9 Travels. We offer one-way and round-trip cab services with AC sedans, SUVs, and luxury cars. Our experienced drivers ensure safe, on-time pickup and smooth travel back to Pune from Shirdi Sai Baba Temple.",
//   "brand": {
//     "@type": "Brand",
//     "name": "S9 Travels"
//   },
//   "aggregateRating": {
//     "@type": "AggregateRating",
//     "bestRating": "5",
//     "worstRating": "1",
//     "ratingValue": "4.8",
//     "ratingCount": "3921"
//   },
//   "offers": {
//     "@type": "Offer",
//     "priceCurrency": "INR",
//     "price": "3499",
//     "availability": "https://schema.org/InStock",
//     "url": "https://www.s9travels.com/Shirdi-to-Pune-Cab"
//   }
// };


      
const productSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Shirdi to Pune Cab Service – S9 Travels",
    "image": "https://s9travels.com/images/keyword/shirdi-to-pune-cab.jpg",
    "description":
      "Book Shirdi to Pune cab from ₹2499 with S9 Travels. Choose Hatchback, Sedan, SUV, or Innova Crysta for one-way or round-trip journeys. Enjoy safe, affordable, and comfortable travel with professional drivers, clean AC cars, 24/7 support, and instant online booking.",
    "brand": {
      "@type": "Brand",
      "name": "S9 Travels"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.9",
      "ratingCount": "7528"
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": "INR",
      "price": "2499",
      "availability": "https://schema.org/InStock",
      "url": "https://s9travels.com/shirdi-to-pune-cab"
    }
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What is the fare for Shirdi to Pune cab?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "S9 Travels offers Shirdi to Pune cab fares starting from ₹2499 for Hatchback, ₹2799 for Sedan, and ₹3299 for SUV or Innova Crysta. Transparent pricing with no hidden charges."
        }
      },
      {
        "@type": "Question",
        "name": "Does S9 Travels provide one-way cab from Shirdi to Pune?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "Yes, S9 Travels provides both one-way and round-trip Shirdi to Pune cab services. Ideal for Sai Baba Temple visitors returning to Pune or business travelers seeking convenient transfers."
        }
      },
      {
        "@type": "Question",
        "name": "How long does it take to travel from Shirdi to Pune?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "The distance from Shirdi to Pune is around 185 km and usually takes 4–5 hours by road via the Ahmednagar route. S9 Travels ensures smooth rides with experienced drivers and comfortable cars."
        }
      },
      {
        "@type": "Question",
        "name": "Do you offer pickups from hotels or Sai Baba Temple?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "Yes, S9 Travels offers flexible pickups from Sai Baba Temple, Shirdi hotels, or anywhere in the city. You can schedule your return trip as per your convenience."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "S9 Travels",
    "image": "https://s9travels.com/images/logo.png",
    "url": "https://s9travels.com/",
    "telephone": "+91 7090759555",
    "priceRange": "₹₹",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Wakad Road, Pimpri-Chinchwad",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "postalCode": "411057",
      "addressCountry": "IN"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "ratingCount": "7528"
    },
    "openingHours": "Mo-Su 00:00-23:59",
    "areaServed":
      "Shirdi, Pune, Ahmednagar, Khed, Chakan, Pimpri Chinchwad, Hadapsar, Hinjewadi, Kothrud"
  };


  

    return (
        <div>

      
  <Helmet>
      {/* ✅ Title */}
      <title>
        Shirdi to Pune Cab from ₹2499 | One-Way Taxi, Sai Baba Temple Return – S9 Travels
      </title>

      {/* ✅ Meta Description */}
      <meta
        name="description"
        content="Book Shirdi to Pune cab service from ₹2499 with S9 Travels. Comfortable AC cars for one-way or round-trip travel with professional drivers, 24/7 support, and on-time pickup from Sai Baba Temple or hotels."
      />

      {/* ✅ Meta Keywords */}
      <meta
        name="keywords"
        content="Shirdi to Pune Cab, Shirdi to Pune Taxi, One Way Cab Shirdi to Pune, Round Trip Taxi Shirdi Pune, Sai Baba Temple Return Cab, Shirdi to Pune Innova Crysta, SUV Taxi Shirdi Pune, Online Cab Booking Shirdi to Pune, Shirdi to Pune Airport Drop, S9 Travels Shirdi Pune Cab Service"
      />

      {/* ✅ Canonical URL */}
      <link rel="canonical" href="https://s9travels.com/shirdi-to-pune-cab" />

      {/* ✅ Structured Data */}
      <script type="application/ld+json">{JSON.stringify(productSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(localBusinessSchema)}</script>

      {/* ✅ Open Graph Meta */}
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Shirdi to Pune Cab from ₹2499 | One-Way & Round-Trip Taxi | S9 Travels"
      />
      <meta
        property="og:description"
        content="Travel from Shirdi to Pune with S9 Travels starting at ₹2499. Safe, clean, and reliable AC cars for Sai Baba Temple visitors and Pune return travelers."
      />
      <meta
        property="og:image"
        content="https://s9travels.com/images/keyword/shirdi-to-pune-cab.jpg"
      />
      <meta property="og:url" content="https://s9travels.com/shirdi-to-pune-cab" />
      <meta property="og:site_name" content="S9 Travels" />

      {/* ✅ Twitter Card Meta */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Shirdi to Pune Cab from ₹2499 | One-Way Taxi & Round Trip | S9 Travels"
      />
      <meta
        name="twitter:description"
        content="Book Shirdi to Pune cab from ₹2499. 24x7 clean AC cars, verified chauffeurs, and on-time pickup from Sai Baba Temple. Reliable one-way & round-trip service."
      />
      <meta
        name="twitter:image"
        content="https://s9travels.com/images/keyword/shirdi-to-pune-cab.jpg"
      />
    </Helmet>



       {/*     <Helmet>
  <title>Shirdi to Pune Cab | S9 Travels</title>
  <meta 
    name="description" 
    content="Book Shirdi to Pune cab services with S9 Travels. Choose from one-way or round-trip taxis with professional drivers and AC vehicles. Enjoy a safe, smooth, and affordable ride back to Pune from Shirdi." 
  />
  <meta 
    name="keywords" 
    content="Shirdi to Pune Cab, Shirdi to Pune Taxi, One Way Cab Shirdi to Pune, Round Trip Shirdi Pune Taxi, Shirdi to Pune Car Hire, Cab from Shirdi to Pune, Luxury Cab Shirdi to Pune, S9 Travels Shirdi Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet> 
// by this 6:2
*/}

      
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/91.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Shirditopunecab;